export default __webpack_public_path__ + "static/media/editIcon.9e44894d.svg";